import React, { useState } from "react";
import { Container } from "react-bootstrap";
import about1 from "../../assets/Images/About/KGM-74.jpg";
import { useIsMobile } from "../../utils/responsive";

export default function Section1() {
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useIsMobile();

  return (
    <Container fluid className="p-0">
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        {!isMobile && (
          <div
            style={{
              width: isMobile ? "100%" : "45%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "50%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
          </div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0">
              A FORMATIVE JOURNEY IN INTERIOR DESIGN
            </h3>
          </div>

          <div
            style={{
              width: "100%",
              height: "50%",
              // borderTop: "1px solid black",
              // borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>

      {/* Main Content Row */}
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img
              src={about1}
              alt="Profile 1"
              className="image-cover-full-responsive"
              style={{
                transition: "all 0.5s ease",
                transform: isHovered ? "scale(1.05)" : "scale(1)",
                filter: isHovered ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>

        {/* Text Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <p className="body-lg m-0">
              <span className="accent-text">Kritika's career&nbsp;</span>
              commenced at Design & Development, where she mastered the art of
              spatial storytelling. Her early years were marked by a diverse
              portfolio, encompassing residential, corporate, hospitality, and
              healthcare projects. Working on corporate floor plans for industry
              giants such as Group 4 Securitas, CSC, and Accenture, she
              developed a keen understanding of layout optimization—an expertise
              that continues to inform her design sensibilities today.
            </p>
            <br />
            <p className="body-lg m-0">
              A particularly transformative experience was her involvement in
              the Max Hospitals project, where she recognized the profound
              impact of interior spaces on well-being. She vividly recalls
              designing an MRI room—little knowing that years later, she would
              find herself on the other side of that very space during her
              battle with cancer. This personal experience reinforced her belief
              in the healing potential of well-designed environments.
            </p>
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
